export default __webpack_public_path__ + "static/FuturaStdMediumOblique-208bdaa2df0b306b10cb0929b3d9f8e6.woff2";